import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import FormField from '../../../core/components/FormField.tsx';
import StringField from '../../../core/components/Fields/StringField.tsx';
import SelectField from '../../../core/components/Fields/SelectField.tsx';
import React from 'react';
import { LANGUAGE_OPTIONS } from '../constants.ts';

const VoiceAgentDetailsFormFields = ({ form, teamOptions }) => {
    const { t } = useTranslation('voice_agents');
    const formErrors = form.formState.errors;

    return (
        <div className="flex flex-col gap-4">
            <Controller
                name="name"
                control={form.control}
                rules={{ required: t('form.nameRequiredError') as string }}
                render={({ field }) => (
                    <FormField label={t('form.name')} required={true} error={formErrors.name}>
                        <StringField required={true} {...field} placeholder={t('form.namePlaceholder')} />
                    </FormField>
                )}
            />

            <Controller
                name="teamId"
                control={form.control}
                render={({ field }) => (
                    <FormField label={t('form.team')} error={formErrors.teamId} helpText={t('form.teamHelpText')}>
                        <SelectField {...field} options={teamOptions} renderOption={(option) => option.label} />
                    </FormField>
                )}
            />

            <Controller
                name="language"
                control={form.control}
                render={({ field }) => (
                    <FormField
                        label={t('form.language')}
                        error={formErrors.language}
                        helpText={t('form.languageHelpText')}
                    >
                        <SelectField {...field} options={LANGUAGE_OPTIONS} renderOption={(option) => option.label} />
                    </FormField>
                )}
            />
        </div>
    );
};

export default VoiceAgentDetailsFormFields;
